import { render, staticRenderFns } from "./MatchingReceivePopups.vue?vue&type=template&id=4f95f6b8"
import script from "./MatchingReceivePopups.vue?vue&type=script&lang=js"
export * from "./MatchingReceivePopups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports